import React from 'react';
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TableView, { useTable, IColumn, IItem } from 'packages/ui/Table'
import ScrollTable from 'components/global/CUK/ScrollTable'
import TableSkeleton from 'components/global/CUK/Skeletons/TableSkeleton'
import COLUMNS_CONFIG from './columns-config'
import useProjects from '../../use-projects'
import { useProjectsSort } from '../../store'

const Table = () => {
  const { t } = useTranslation()
  const apiProjects = useProjects()
  const [sort, setSort] = useProjectsSort()
  
  const apiTable = useTable({
    rowKey: 'id',
    loading: apiProjects.loading,
    loadingNext: apiProjects.loadingNext,
    items: (apiProjects?.projects || []) as unknown as IItem[],
    columns: COLUMNS_CONFIG
  })

  return (
    <Stack
      sx={{
        overflow: 'hidden',
        overflowY: 'auto',
        flex: '1 1 auto',
        scrollbarWidth: 'none',
        height: '100%',
        '&::-webkit-scrollbar ': {
          display: 'none'
        }
      }}
    >
      <ScrollTable
        height={270}
        fetchNextPage={apiProjects.fetchNextPage}
        shouldFetchNextPage={apiProjects.shouldFetchNextPage}
      >
        {
          apiProjects.loading
            ? <TableSkeleton />
            : (
              <TableView
                apiTable={apiTable}
                endMessage={!apiProjects.shouldFetchNextPage && apiProjects.projects.length > 0
                  ? t('projects.table.all_projects_displayed')
                  : undefined}
                sort={{
                  ...sort,
                  direction: sort.direction as string,
                  by: sort.by as string,
                  onChange: name => {
                    const column = COLUMNS_CONFIG.find(column => column.name === name) as IColumn
                    setSort(column?.sortBy || column?.name)
                  }
                }}
              />
            )
        }
      </ScrollTable>
    </Stack>
  )
}

export default Table